import dayjs from "dayjs";
import { businessDays } from "./../constants";
import {
  OccupancyData,
  SchedulerProjectData,
  TimeUnits,
  ZoomLevel,
} from "./../types/global";
import { getDuration } from "./getDuration";
import { getTotalHoursAndMinutes } from "./getTotalHoursAndMinutes";
import { getTimeOccupancy } from "./getTimeOccupancy";

export const getWeekOccupancy = (
  occupancy: SchedulerProjectData[],
  focusedDate: dayjs.Dayjs,
  zoom: ZoomLevel
): OccupancyData => {
  const focusedWeek = focusedDate.isoWeek();

  function getHoursAndMinutes(occupancy: SchedulerProjectData[]): TimeUnits[] {
    return occupancy.map((item) => {
      const startWeekNum = dayjs(item.startDate).isoWeek();
      const startDateDayNum = dayjs(item.startDate).isoWeekday();

      const endWeekNum = dayjs(item.endDate).isoWeek();
      const endDateDayNum = dayjs(item.endDate).isoWeekday();

      const { hours: itemHours, minutes: itemMinutes } = getDuration(
        Math.round(item.hoursPerDay) * 60 * 60
      );

      if (focusedWeek === startWeekNum) {
        const hours = (businessDays + 1 - startDateDayNum) * itemHours;
        const minutes = (businessDays + 1 - startDateDayNum) * itemMinutes;
        return { hours: Math.max(0, hours), minutes };
      } else if (focusedWeek === endWeekNum) {
        const hours =
          endDateDayNum > businessDays
            ? businessDays * itemHours
            : endDateDayNum * itemHours;
        const minutes =
          endDateDayNum > businessDays
            ? businessDays * itemMinutes
            : endDateDayNum * itemMinutes;
        return { hours, minutes };
      } else if (dayjs(focusedDate).isBetween(item.startDate, item.endDate)) {
        return {
          hours: businessDays * itemHours,
          minutes: businessDays * itemMinutes,
        };
      }
      return { hours: 0, minutes: 0 };
    });
  }

  const allocationOcupancy: SchedulerProjectData[] = [];
  const allocationGroupOcupancy: SchedulerProjectData[] = [];
  const unavailabilityOcupancy: SchedulerProjectData[] = [];
  const projectionOcupancy: SchedulerProjectData[] = [];

  for (const item of occupancy) {
    if (item.isProjection) projectionOcupancy.push(item);
    else if (!item.isProject) unavailabilityOcupancy.push(item);
    else if (item.linkId) allocationGroupOcupancy.push(item);
    else allocationOcupancy.push(item);
  }

  const { hours: totalHours, minutes: totalMinutes } = getTotalHoursAndMinutes(
    getHoursAndMinutes(occupancy)
  );
  const { free, overtime } = getTimeOccupancy(
    { hours: totalHours, minutes: totalMinutes },
    zoom
  );

  return {
    taken: {
      hours: Math.max(0, totalHours),
      minutes: Math.max(0, totalMinutes),
    },
    free,
    overtime,
    allocation: allocationOcupancy.length
      ? getTotalHoursAndMinutes(getHoursAndMinutes(allocationOcupancy))
      : { hours: 0, minutes: 0 },
    allocationGroup: allocationGroupOcupancy.length
      ? getTotalHoursAndMinutes(getHoursAndMinutes(allocationGroupOcupancy))
      : { hours: 0, minutes: 0 },
    unavailability: unavailabilityOcupancy.length
      ? getTotalHoursAndMinutes(getHoursAndMinutes(unavailabilityOcupancy))
      : { hours: 0, minutes: 0 },
    projection: projectionOcupancy.length
      ? getTotalHoursAndMinutes(getHoursAndMinutes(projectionOcupancy))
      : { hours: 0, minutes: 0 },
  };
};
